import { Box, Button, Flex, HStack, Text } from "@chakra-ui/react";
import { ChevronLeft, ArrowRight, Sparkles } from "lucide-react";
import { STEPS } from "../constants";

export function OnboardingFooter({
  currentStep,
  isCompleted,
  isSaving,
  isUploading,
  isSubmitting,
  hasApplication,
  prevStep,
  handleContinue,
  handleFinalSubmit,
  onNewApplication,
}: {
  currentStep: number;
  isCompleted: boolean;
  isSaving: boolean;
  isUploading: boolean;
  isSubmitting: boolean;
  hasApplication: boolean;
  prevStep: () => void;
  handleContinue: () => void;
  handleFinalSubmit: () => void;
  onNewApplication: () => void;
}) {
  if (isCompleted) return null;

  return (
    <Box
      bg="white"
      borderTop="1px solid"
      borderColor="gray.100"
      px={6}
      py={5}
      flexShrink={0}
      zIndex={20}
      boxShadow="0 -6px 18px rgba(15,23,42,0.04)"
    >
      <Box maxW="4xl" mx="auto">
        <Flex justifyContent="space-between" alignItems="center">
          {hasApplication && currentStep === 1 ? (
            <Button
              variant="ghost"
              color="gray.600"
              onClick={onNewApplication}
              _hover={{ bg: "gray.100" }}
            >
              Nueva solicitud
            </Button>
          ) : currentStep > 1 ? (
            <Button
              onClick={prevStep}
              variant="ghost"
              color="gray.600"
              _hover={{ bg: "gray.100", color: "gray.900" }}
            >
              <ChevronLeft size={20} />
              Atrás
            </Button>
          ) : (
            <Box />
          )}

          {(isSaving || isUploading) && (
            <HStack gap={2} fontSize="sm" color="gray.400" ml="auto" mr={4}>
              <Box
                w={4}
                h={4}
                borderWidth="2px"
                borderColor="gray.300"
                borderTopColor="gray.500"
                borderRadius="full"
                animation="spin 0.8s linear infinite"
              />
              Guardando...
            </HStack>
          )}

          {currentStep < STEPS.length ? (
            <Button
              colorPalette="palomma"
              onClick={handleContinue}
              disabled={isSaving || isUploading}
              boxShadow="lg"
              ml="auto"
            >
              Continuar
              <ArrowRight size={20} />
            </Button>
          ) : (
            <Button
              onClick={handleFinalSubmit}
              disabled={isSubmitting || isSaving || isUploading}
              bg="gray.900"
              color="white"
              _hover={{ bg: "black" }}
              _disabled={{
                bg: "gray.300",
                cursor: "not-allowed",
                boxShadow: "none",
              }}
              boxShadow="xl"
              ml="auto"
            >
              {isSubmitting ? (
                <HStack gap={2}>
                  <Box
                    w={5}
                    h={5}
                    borderWidth="2px"
                    borderColor="white"
                    borderTopColor="transparent"
                    borderRadius="full"
                    animation="spin 0.8s linear infinite"
                    as="span"
                  />
                  <Text>Procesando...</Text>
                </HStack>
              ) : (
                <>
                  Enviar solicitud
                  <Sparkles size={20} />
                </>
              )}
            </Button>
          )}
        </Flex>
      </Box>
    </Box>
  );
}
